/**
 * External Tools Configuration — SSO Launcher
 * URLs de las herramientas externas por ambiente.
 * Usado exclusivamente por LaunchPage (componente de prueba SSO).
 */

export interface ExternalTool {
  id: string;
  name: string;
  description: string;
  sso: boolean;
  ssoPath?: string;     // Requerido solo cuando sso: true
  vpn?: boolean;        // Si true, requiere VPN para acceder
  vpnHealthUrl?: string; // Endpoint para verificar conectividad VPN
  urls: {
    local: string;
    qa: string;
    prod: string;
  };
}

export const EXTERNAL_TOOLS: ExternalTool[] = [
  {
    id: 'inventory',
    name: 'Inventory Portal',
    description: 'Gestión de inventario de propiedades',
    sso: true,
    ssoPath: '/sso',
    urls: {
      local: 'http://localhost:3002',
      qa: 'https://inventory.llavero.co',
      prod: 'https://inventory.habi.co',
    },
  },
  {
    id: 'portal-pricing',
    name: 'Portal Pricing',
    description: 'Valuación y precios de propiedades',
    sso: true,
    ssoPath: '/sso',
    urls: {
      local: 'http://localhost:3001',
      qa: 'https://pricing.llavero.co',
      prod: 'https://pricing.habi.co',
    },
  },
  {
    id: 'segmentation',
    name: 'Segmentación',
    description: 'Segmentación de precios por zona',
    sso: false,
    vpn: true,
    vpnHealthUrl: 'https://monorepo-price-segmentation.im.private.habi.co/health',
    urls: {
      local: 'https://segmentation.llavero.co/segmentation',
      qa: 'https://segmentation.llavero.co/segmentation',
      prod: 'https://segmentation.habi.co/segmentation',
    },
  },
  {
    id: 'aprobologia',
    name: 'Aprobología',
    description: 'Portal de aprobación de zonas',
    sso: false,
    urls: {
      local: 'http://localhost:3003',
      qa: 'https://portal-zonas.llavero.co/iniciar-sesion',
      prod: 'https://portal-zonas.habi.co/iniciar-sesion',
    },
  },
  {
    id: 'cortex',
    name: 'Cortex AT Console',
    description: 'Consola de Trading Algorítmico — HeSH, Committee y Assembly',
    sso: false,
    vpn: true,
    vpnHealthUrl: 'https://cortex-front-domain-cortex.im.private.habi.co/api/health',
    urls: {
      local: 'http://localhost:3010',
      qa:   'https://cortex-front-domain-cortex-dev.im.private.llavero.co',
      prod: 'https://cortex-front-domain-cortex.im.private.habi.co',
    },
  },
];

/**
 * Detecta el ambiente actual según el hostname
 */
export const getCurrentEnvironment = (): 'local' | 'qa' | 'prod' => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'local';
  if (hostname.includes('llavero.co')) return 'qa';
  return 'prod';
};

/**
 * Retorna la URL base de una herramienta según el ambiente actual
 */
export const getToolUrl = (tool: ExternalTool): string => {
  const env = getCurrentEnvironment();
  return tool.urls[env];
};

